// divisionApi.js
import api from '@api';

export async function fetchDivision(seasonId, divisionId) {
  const res = await api.get(`/api/seasonsv2/${seasonId}/divisions/${divisionId}`, { withCredentials: true });
  return res.data;
}

export async function fetchGames(seasonId, divisionId) {
  const res = await api.get(`/api/seasonsv2/${seasonId}/divisions/${divisionId}/games`);
  return res.data;
}

export async function createGame(seasonId, divisionId, gameData) {
  const res = await api.post(`/api/seasonsv2/${seasonId}/divisions/${divisionId}/games`, gameData, { withCredentials: true });
  return res.data;
}

export async function updateGame(seasonId, divisionId, gameId, gameData) {
  const res = await api.put(
    `/api/seasonsv2/${seasonId}/divisions/${divisionId}/games/${gameId}`,
    gameData,
    { withCredentials: true }
  );
  return res.data;
}


export async function deleteGame(seasonId, divisionId, gameId) {
  const res = await api.delete(`/api/seasonsv2/${seasonId}/divisions/${divisionId}/games/${gameId}`, { withCredentials: true });
  return res.data;
}
